module.exports = __webpack_public_path__ + "img/cover_photo.8b93ce62.jpg";